import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../../chunks/tslib.es6.js";
import r from "../../../core/Accessor.js";
import t from "../../../core/Logger.js";
import { isNone as o } from "../../../core/maybe.js";
import { property as s } from "../../../core/accessorSupport/decorators/property.js";
import "../../../core/arrayUtils.js";
import "../../../core/has.js";
import "../../../core/accessorSupport/ensureType.js";
import { subclass as i } from "../../../core/accessorSupport/decorators/subclass.js";
import { isLoaded as n, project as m } from "../../../geometry/projection.js";
import { extentContainsPoint as a, polygonContainsPoint as c } from "../../../geometry/support/contains.js";
import { nearestCoordinate as p } from "../../../geometry/support/near.js";
import { canProject as l, project as y } from "../../../geometry/support/webMercatorUtils.js";

var _u;

var g = t.getLogger("esri.views.MapView");

var h = _u = /*#__PURE__*/function (_r) {
  _inherits(u, _r);

  var _super = _createSuper(u);

  function u(e) {
    var _this;

    _classCallCheck(this, u);

    _this = _super.call(this, e), _this.geometry = null, _this.spatialReference = null;
    return _this;
  }

  _createClass(u, [{
    key: "normalizedGeometry",
    get: function get() {
      return o(this.geometry) || !this.spatialReference ? null : this.spatialReference.equals(this.geometry.spatialReference) ? this.geometry : l(this.geometry, this.spatialReference) ? y(this.geometry, this.spatialReference) : n() ? m(this.geometry, this.spatialReference) : (g.error("#constraints.geometry", "unsupported coordinate system. The source geometry cannot be projected to the view's coordinate system. The projection engine cannot be loaded.", {
        geometry: this.geometry
      }), null);
    }
  }, {
    key: "constrain",
    value: function constrain(e, r) {
      if (o(this.normalizedGeometry)) return e;
      var t = e.targetGeometry;
      if ("extent" === this.normalizedGeometry.type ? a(this.normalizedGeometry, t) : c(this.normalizedGeometry, t)) return e;

      var _p = p(this.normalizedGeometry, t),
          s = _p.coordinate;

      return s ? (e.targetGeometry = s, e) : e;
    }
  }, {
    key: "clone",
    value: function clone() {
      var e, r;
      return new _u({
        geometry: null == (e = this.geometry) ? void 0 : e.clone(),
        spatialReference: null == (r = this.spatialReference) ? void 0 : r.clone()
      });
    }
  }]);

  return u;
}(r);

e([s({
  constructOnly: !0
})], h.prototype, "geometry", void 0), e([s({
  readOnly: !0
})], h.prototype, "normalizedGeometry", null), e([s({
  constructOnly: !0
})], h.prototype, "spatialReference", void 0), h = _u = e([i("esri.views.2d.constraints.GeometryConstraint")], h);
export { h as GeometryConstraint };